//localhost
// const backendLink = "http://base.localhost:8000/api/complaints/";
// const configLink = "http://base.localhost:8000/api/tenants/admin/";
// const dataLink = "http://localhost:3000/user";
// const uploadsLink = "http://localhost/Jawda_base_V2_tenancy/jawdaBackend/uploads";
// const backendLinkSuggestion = "http://base.localhost:8000/api/v2/user/suggestion/";
// const backendLinkLottery = "https://base.localhost:8000/api/v2/user/lottery/";
// const backendLinkComplaint = "https://base.localhost:8000/api/v2/user/complaint/";

// const backendLink = "https://base.jawdaplus.click/api/complaints/";
// const configLink = "https://base.jawdaplus.click/api/tenants/admin/";
// const dataLink = "http://localhost:3000/user";
// const backendLinkComplaint = "https://base.jawdaplus.click/api/v2/user/complaint/";
// const backendLinkLottery = "https://base.jawdaplus.click/api/v2/user/lottery/";
// const backendLinkSuggestion = "https://base.jawdaplus.click/api/v2/user/suggestion/";

// server
const dataLink = "/user";
const backendLink = "/api/complaints/";
const configLink = "/api/tenants/admin/";
const backendLinkComplaint = "/api/v2/user/complaint/";
const backendLinkLottery = "/api/v2/user/lottery/";
const backendLinkSuggestion = "/api/v2/user/suggestion/";

export { backendLink, configLink, dataLink, backendLinkComplaint, backendLinkLottery, backendLinkSuggestion };
